<!-- 权限申请历史 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <processAuditAction ref="processAuditAction"></processAuditAction>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
               <el-form-item label="申请人">
                  <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人')"></label>
                  <el-input v-model.trim="getRequestData.opmName" placeholder="名称" @keyup.enter.native="$refs['showSelectData'].openBox('opmList','opmId','opmId',getRequestData.opmName)" clearable>
                     <el-button @click="$refs['showSelectData'].openBox('opmList','opmId','opmId',getRequestData.opmName)" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
               </el-form-item>
               <el-form-item label="申请人" v-show="false">
                  <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人')"></label>
                  <el-input v-model.trim="getRequestData.opmName" placeholder="名称" @focus="$refs['showSelectData'].openBox('opmList','opmId','opmId')" clearable>
                  </el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="gpmId" label="申请编号" min-width="160">
               <template slot-scope="scope">
                  <a @click="toDetail(scope.row.gpmId)">{{ scope.row.gpmId }}</a>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="opmName" label="申请人">
            </el-table-column>
            <el-table-column align="center" prop="gpmRemark" label="申请岗位名称">
            </el-table-column>
            <el-table-column align="center" prop="gpmCreatetime" label="申请时间">
               <template slot-scope="scope">
                  <div v-if="scope.row.gpmCreatetime">
                     {{$common.getLocalTime(scope.row.gpmCreatetime)}}
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="状态" prop="gpmState" min-width="100">
               <template slot-scope="scope">
                  <span>
                     {{$common.getIsGsp('[{"key":0,"value":"初始"},{"key":-1,"value":"审核退回"},{"key":1,"value":"提交审核"},{"key":2,"value":"审核通过"}]', scope.row.gpmState)}}
                  </span>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="createrName" label="创建人">
            </el-table-column>
            <el-table-column align="center" prop="remark" label="备注">
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="dialogVisible" :visible.sync="dialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         buttonList: [],
         getRequestData: {
            opmName: '',
            opmId: '',
            ormId: '',
            page: 1,
            rows: 30,
            end: '',
            start: '',
         },
         returnData: {
            pages: 0,  // 总页数
            total: 0,  // 总条数
            pageNum: 0,  // 当前页数
            list: []
         },
         selectedDataIndex: 0,
         dialogVisible: false,
         parentSearchData: {},
         seId: '',
         seIndex: '',
         seType: '',
         sField: ''
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.opmName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.opmId = ''
            }
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: {
                     isPenetrate,
                  }, //参数
               },
               "*"
            );
         }
      },
      openSearch(sId, index, type, sField) {
         this.dialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type];
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getPageInfo() {
         this.getDataList()
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.dialogVisible = false;
            this.paramValue(val);
            this.sendDataInfo.gpmRemark = val.opmJob
         }
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      isShowData(name, value) {
         switch (name) {
            case 'opmId':
               var dataInfo = sessionStorage.getItem('selectUserData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.getRequestData.opmId = dataInfo.opmId
                  this.getRequestData.opmName = dataInfo.opmName
               }
               break;
            default:
               this.getRequestData[name] = value

         }
      },



      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 4:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               this.$refs['processAuditAction'].openBox(0, dataInfo.gpmId)
               break;
            case 5:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               this.$refs['processAuditAction'].openBox(1, dataInfo.gpmId)
               break;
            case 8:
               this.showPrintPlan()

         }
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         var pathId = parent.getMenuInfo('/authorityApplyHistory')
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(dataInfo.gpmId, 'printData/authorityPrint', pathId.jurId)
         } else {
            return
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
// 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },


      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getAuthorityApplyHistory(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },



   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getDataList()
      this.getButtonList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
</style>
